<template>
  <div class="row">
    <div class="col-10 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Cliente</label>
      <vue-select
        :options="['Cliente 1', 'Cliente 2', 'Cliente 3']"
        placeholder="-- Seleciona una opción --"
        v-model="clienteSeleccionado"
      ></vue-select>
    </div>
    <div class="col-2 form-check mt-4">
      <input
        class="form-check-input"
        type="checkbox"
        id="checkboxAsociados"
        v-model="checkAsociados"
      />
      <label class="form-check-label text-theme" for="checkboxAsociados"
        >Inc.Asociados</label
      >
    </div>
    <div class="col-12 col-md-6 col-xl-2 mb-3">
      <label class="form-label text-theme">Dirección</label>
      <input class="form-control" v-model="direccion" />
    </div>
    <div class="col-12 col-md-6 col-xl-3 mb-3">
      <label class="form-label text-theme">Provincia</label>
      <vue-select
        :options="['Provincia 1', 'Provincia 2', 'Provincia 3']"
        placeholder="-- Seleciona una opción --"
        v-model="provinciaSeleccionada"
      ></vue-select>
    </div>
    <div class="col-12 col-md-6 col-xl-3 mb-3">
      <label class="form-label text-theme">País</label>
      <vue-select
        :options="['Pais 1', 'Pais 2', 'Pais 3']"
        placeholder="-- Seleciona una opción --"
        v-model="paisSeleccionado"
      ></vue-select>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Fecha de pago</label>
      <VueDatePicker
        locale="es"
        cancelText="Cancelar"
        selectText="Seleccionar"
        :enable-time-picker="false"
        :format-locale="es"
        format="dd/MM/yyyy"
        v-model="fechaPago"
        input-class-name="dp-custom-input"
      ></VueDatePicker>
    </div>
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Zona</label>
      <vue-select
        :options="['Zona 1', 'Zona 2', 'Zona 3']"
        placeholder="-- Seleciona una opción --"
        v-model="zonaSeleccionada"
      ></vue-select>
    </div>
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Actividad</label>
      <vue-select
        :options="['Actividad 1', 'Actividad 2', 'Actividad 3']"
        placeholder="-- Seleciona una opción --"
        v-model="actividadSeleccionada"
      ></vue-select>
    </div>
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Grupo</label>
      <vue-select
        :options="['Grupo 1', 'Grupo 2', 'Grupo 3']"
        placeholder="-- Seleciona una opción --"
        v-model="grupoSeleccionado"
      ></vue-select>
    </div>
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Fecha</label>
      <VueDatePicker
        locale="es"
        cancelText="Cancelar"
        selectText="Seleccionar"
        :enable-time-picker="false"
        :format-locale="es"
        format="dd/MM/yyyy"
        v-model="fecha"
        input-class-name="dp-custom-input"
      ></VueDatePicker>
    </div>
    <div class="col-12 col-md-4 col-xl-2 mb-3">
      <label class="form-label text-theme">Agente</label>
      <vue-select
        :options="['Agente 1', 'Agente 2', 'Agente 3']"
        placeholder="-- Seleciona una opción --"
        v-model="agenteSeleccionado"
      ></vue-select>
    </div>
  </div>
  <p class="text-end mb-0">
    <a href="javascript:;" class="btn btn-white me-5px" @click="clearForm"
      >Borrar</a
    >
    <a href="javascript:;" class="btn btn-theme">Consultar</a>
  </p>
</template>
<script setup>
import { ref, watch } from "vue";
// datepicker
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { es } from "date-fns/locale";
// select
import vueSelect from "@/components/plugins/VueSelect.vue";
// eventos
const emit = defineEmits(['customers-form-updated']);

const clienteSeleccionado = ref();
const checkAsociados = ref(false);
const direccion = ref();
const provinciaSeleccionada = ref();
const paisSeleccionado = ref();
const fechaPago = ref();
const zonaSeleccionada = ref();
const actividadSeleccionada = ref();
const grupoSeleccionado = ref();
const fecha = ref();
const agenteSeleccionado = ref();

const clearForm = () => {
  clienteSeleccionado.value = null;
  checkAsociados.value = false;
  direccion.value = null;
  provinciaSeleccionada.value = null;
  paisSeleccionado.value = null;
  fechaPago.value = null;
  zonaSeleccionada.value = null;
  actividadSeleccionada.value = null;
  grupoSeleccionado.value = null;
  fecha.value = null;
  agenteSeleccionado.value = null;
  emitFormData(); // se emite también después de limpiar el formulario
};

// Crear un método para emitir los datos del formulario
const emitFormData = () => {
  emit("customers-form-updated", {
    clienteSeleccionado: clienteSeleccionado.value,
    checkAsociados: checkAsociados.value,
    direccion: direccion.value,
    provinciaSeleccionada: provinciaSeleccionada.value,
    paisSeleccionado: paisSeleccionado.value,
    fechaPago: fechaPago.value,
    zonaSeleccionada: zonaSeleccionada.value,
    actividadSeleccionada: actividadSeleccionada.value,
    grupoSeleccionado: grupoSeleccionado.value,
    fecha: fecha.value,
    agenteSeleccionado: agenteSeleccionado.value,
  });
};
// Vigilar cambios en los campos del formulario
watch(
  [
    clienteSeleccionado,
    checkAsociados,
    direccion,
    provinciaSeleccionada,
    paisSeleccionado,
    fechaPago,
    zonaSeleccionada,
    actividadSeleccionada,
    grupoSeleccionado,
    fecha,
    agenteSeleccionado,
  ],
  emitFormData
);
</script>
<style lang="scss">
/* estilo del input del datepicker, para que sea igual al form-control */
.dp-custom-input {
  display: block;
  width: 100%;
  padding: 0.4375rem 2rem;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.5;
  color: var(--bs-component-color);
  appearance: none;
  background-color: var(--bs-component-bg);
  background-clip: padding-box;
  border: 1px solid var(--bs-component-border-color);
  border-radius: 4px;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}
/* color de las labels de los inputs, en caso de no quererse usar text-theme */
.labelColor {
  color: #6a7177;
}
</style>
